import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 926FBBF9-9299-4E27-BB55-9CE300F50FDE
 * name alert-remove-outline
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-remove-outline.svg
 * tags
 * - Alert / Error 
 */
export const AlertRemoveOutlineIcon = createSvgIcon(<><path d="M11 15.5H13V17.5H11V15.5M14 19C14 18.86 14 18.73 14 18.6H5.4L12 7.3L16.11 14.44C16.62 14 17.2 13.65 17.84 13.41L12 3.3L2 20.6H14.22C14.08 20.09 14 19.56 14 19M13 10.5H11V14.5H13V10.5M22.12 15.46L20 17.59L17.88 15.46L16.47 16.88L18.59 19L16.47 21.12L17.88 22.54L20 20.41L22.12 22.54L23.54 21.12L21.41 19L23.54 16.88L22.12 15.46Z" /></>, 'AlertRemoveOutlineIcon');
export default AlertRemoveOutlineIcon